/**
 * @copyright 2023 Chris Zuber <admin@kernvalley.us>
 */

// Text and Code
export const TEXT = 'text/plain';
export const PLAIN_TEXT = TEXT;
export const HTML = 'text/html';
export const CSS = 'text/css';
export const JS = 'application/javascript';
export const JSON = 'application/json';
export const JSON_LD = 'application/ld+json';
export const WEB_APP_MANIFEST = 'application/manifest+json';
export const XML = 'application/xml';
export const RSS_XML = 'application/rss+xml';
export const RSS = RSS_XML;
export const ATOM_XML = 'application/atom+xml';
export const ATOM = ATOM_XML;
export const XSLT = 'application/xslt+xml';
export const XHTML = 'application/xhtml+xml';
export const MATH_ML = 'application/mathml+xml';
export const SQL = 'application/sql';
export const MARKDOWN = 'text/markdown';
export const YAML = 'application/x-yaml';
export const TOML = 'application/toml';
export const PHP = 'application/x-httpd-php';
export const BASH = 'application/x-sh';

// Images
export const JPEG = 'image/jpeg';
export const PNG = 'image/png';
export const GIF = 'image/gif';
export const WEBP = 'image/webp';
export const SVG = 'image/svg+xml';
export const AVIF = 'image/avif';
export const ICO = 'image/vnd.microsoft.icon';
export const TIFF = 'image/tiff';
export const GIMP = 'application/x-gimp';

// iOS Images
export const HEIC = 'image/heic';
export const HEIF = 'image/heif';

// Audio
export const OGG_AUDIO = 'audio/ogg';
export const OGA = OGG_AUDIO;
export const MP3 = 'audio/mpeg';
export const AAC = 'audio/aac';
export const OPUS = 'audio/opus';
export const FLAC = 'audio/flac';
export const WAV = 'audio/wav';
export const MIDI = 'audio/midi';
export const M4A = 'audio/mp4';
export const WEBA = 'audio/webm';

// Video
export const WEBM = 'video/webm';
export const OGG_VIDEO = 'video/ogg';
export const OGV = OGG_VIDEO;
export const MP4 = 'video/mp4';
export const M4V = MP4;
export const MPEG = 'video/mpeg';
export const QUICKTIME = 'video/quicktime';
export const WEBVTT = 'text/vtt';

// Fonts
export const WOFF = 'font/woff';
export const WOFF2 = 'font/woff2';
export const TTF = 'font/ttf';
export const OTF = 'font/otf';
export const SVG_FONT = SVG;
export const EOT = 'application/vnd.ms-fontobject';

// Office Documents
export const CSV = 'text/csv';
export const RTF = 'application/rtf';
export const PDF = 'application/pdf';
export const ICAL = 'text/calendar';
export const VCARD = 'text/vcard';

// Libre Office and Open Office
export const LIBRE_OFFICE_TEXT = 'application/vnd.oasis.opendocument.text';
export const LIBRE_OFFICE_SPREADSHEET = 'application/vnd.oasis.opendocument.spreadsheet';
export const LIBRE_OFFICE_PRESENTATION = 'application/vnd.oasis.opendocument.presentation';

// Microsoft Office
export const MS_DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const MS_DOC = 'application/msword';
export const MS_WORD = MS_DOCX;
export const MS_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const MS_XLS = 'application/vnd.ms-excel';
export const MS_EXCEL = MS_XLSX;
export const MS_PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
export const MS_PPT = 'application/vnd.ms-powerpoint';
export const MS_POWERPOINT = MS_PPTX;

// Compressed Archives
export const GZIP = 'application/gzip';
export const ZIP = 'application/zip';
export const TAR = 'application/x-tar';
export const SEVEN_ZIP = 'application/x-7z-compressed';

// Adobe Types
export const ADOBE_PDF = PDF;
export const ADOBE_POSTSCRIPT = 'application/postscript';
export const ADOBE_ILLUSTRATOR = 'application/illustrator';
export const ADOBE_PHOTOSHOP = 'image/vnd.adobe.photoshop';
export const ADOBE_FLASH = 'application/x-shockwave-flash';
export const ADOBE_PREMIERE = 'application/x-premiere';
export const ADOBE_AFTER_EFFECTS = 'application/x-after-effects';

// Other
export const FORM_URL_ENCODED = 'application/x-www-form-urlencoded';
export const FORM_MULTIPART = 'multipart/form-data';
export const OCTET_STREAM = 'application/octet-stream';
